export const capitalize = (word: string) => {
  return word.substring(0, 1).toUpperCase().concat(word.substring(1))
}
